import { useSessionStore } from '@/stores'
import { jsonRpc, messenger } from '@communication'
export default class ParticipantReadyProcedure {
  constructor() {
    this.name = 'participantReadyProcedure'
  }

  install = () => {
    jsonRpc.on('con:ready', this.handler)
  }

  uninstall = () => {
    messenger.unsubscribe(this.name)
    jsonRpc.off('con:ready', this.handler)
  }

  handler = (event) => {
    const { id } = event.detail
    const session = useSessionStore()
    session.updateParticipant(id, { status: 'online' })
  }
}
